import React from 'react';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';
import {Glyphicon} from "../../Common/GlyphIcon";
import {usePublic} from "../../../Hooks/PermissionHooks";

export function StreamBankChartLegendItemHelpIcon(props) {
    const isPublic = usePublic();

    if(!props.DataSet || isPublic) {
        return null;
    }
    let helpText = null;

    if(props?.EnvironmentalBenefit?.code !== 'solar-load-reduction') {
        return null;
    }

    if(props.DataSet.label) {
        if(props.DataSet.label === "Projects") {
        } else if (props.DataSet.label.startsWith("Target ")) {
            helpText = "Thermal Benefit Obligation";
        } else if (props.DataSet.label.startsWith("Implemented ")) {
            helpText = "Aggregate Thermal Benefits";
        } else if (props.DataSet.label.startsWith("Projected ")) {
        } else if (props.DataSet.label.startsWith("Milestone")) {
        }
    }

    if(helpText) {
        let tooltip = <Tooltip id={"sb-chart-help-icon-tooltip-" + props.DataSet.label.replace(" ", "-")}>{helpText}</Tooltip>;

        return <OverlayTrigger placement="bottom" overlay={tooltip}>
            <span><Glyphicon className="help-icon" glyph="question-sign" /></span>
        </OverlayTrigger>;
    }

    return null;
};
